module.exports = __webpack_public_path__ + "static/media/facebook.616fe2e6.svg";